import React from 'react';
import { Button } from '@teals/ui-web';

type AnalyticsReloadButtonProps = {
  onReload: () => void;
  disabled?: boolean;
};

/** Icon-only control to refetch Analytics queries. */
const AnalyticsReloadButton: React.FC<AnalyticsReloadButtonProps> = ({
  onReload,
  disabled,
}) => (
  <Button
    variant="outline"
    size="sm"
    aria-label="Reload analytics"
    title="Reload analytics"
    onClick={onReload}
    disabled={disabled}
    style={{
      minWidth: '2.25rem',
      padding: '0.35rem 0.5rem',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  </Button>
);

export default AnalyticsReloadButton;
